<div class="content-heading">
  <div class="header-container">
    <h3>Líneas de Transportes</h3>
    <small>Catálogo de líneas de transportes y transportistas</small>
  </div>
</div>


<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <div class="card card-default">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-xs-12">

              <div class="row filter-container d-flex align-items-end mb-2">
                <div class="col-md-5">
                  <label class="text-bold">Buscar Línea de Transporte</label>
                  <div class="ng-autocomplete">
                    <ng-autocomplete placeholder="Escribe el nombre de la línea..." [data]="lineList"
                      [searchKeyword]="keyword" (selected)='selectEvent($event)' (inputCleared)="cmbLines()"
                      [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate" [(ngModel)]="selectedLine">
                    </ng-autocomplete>

                    <ng-template #itemTemplate let-item>
                      <a [innerHTML]="item.LineName"></a>
                    </ng-template>

                    <ng-template #notFoundTemplate let-notFound>
                      <div [innerHTML]="'No se encontraron coincidencias'"></div>
                    </ng-template>
                  </div>
                </div>
                <div class="ml-auto mr-3">
                  <aph-custom-buttons type="button" preset="refresh" (btnClick)="refresh()"
                    style="margin-bottom: -8px;"></aph-custom-buttons>
                </div>
              </div>
              <div class="row">
                <app-ceq-table #CeqGrid class="col-12" [gridAdditionalOptions]="gridOptions" [columnDef]="columnDefs"
                  (apiEmitter)="gridEmiter($event)">
                </app-ceq-table>
              </div>

            </div>
            <div class="col-md-12 col-xs-12 mt-3">
              <aph-custom-buttons preset="add" label="Nueva línea" (btnClick)="btnAddClick()">
              </aph-custom-buttons>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>